import { getGlobalSettings } from '../../../../../utils/global_settings';

export const rootNode = document.getElementById('prospect-top-charts-apps-root');

export const initParams = () => ({
  data: JSON.parse(rootNode.dataset.data),
  report: JSON.parse(rootNode.dataset.report),
  defaultOsName: rootNode.dataset.defaultOsName,
  defaultStoreName: rootNode.dataset.defaultStoreName,
  store: rootNode.dataset.store,
  shareOptions: JSON.parse(rootNode.dataset.shareOptions),
  availableCategories: JSON.parse(rootNode.dataset.availableCategories),
  allowAppQuickView: getGlobalSettings().permissions.allowAppQuickView,
});

export const parseUrlForFilters = () => {
  const { pathname, search } = window.location;
  const allFilters = pathname.match(
    /\/store-insights\/top-charts\/(google-play|itunes-connect)\/([a-z-]+)?\/([a-z-]+)?/
  );
  const defaultFilters = pathname.match(/\/store-insights\/top-charts/);
  const urlParams = new URLSearchParams(search);
  let filters = {};
  if (allFilters) {
    filters = { store: allFilters[1], category: allFilters[2], country: allFilters[3] };
  }

  if (!allFilters && defaultFilters) {
    filters = { store: defaultFilters[1] };
  }

  if (urlParams.get('date')) {
    filters = { ...filters, date: urlParams.get('date') };
  }

  return filters;
};
